import { render, staticRenderFns } from "./edit-dialog-receiver-update.vue?vue&type=template&id=2a26360a&"
import script from "./edit-dialog-receiver-update.vue?vue&type=script&lang=js&"
export * from "./edit-dialog-receiver-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports